import React from 'react';
import PropTypes from 'prop-types';
import SpinJS from 'spin.js';
import Colors from 'common/constants/colors';
import './index.scss';

export default class Spinner extends React.Component {
  static propTypes = {
    config: PropTypes.object,
    style: PropTypes.object,
  };

  static defaultProps = {
    config: {
      className: 'Spinner',
      color: Colors.black,
      corners: 1,
      hwaccel: true,
      top: '50%',
      left: '50%',
      length: 9,
      lines: 11,
      radius: 13,
      rotate: 15,
      shadow: false,
      speed: 1,
      trail: 40,
      width: 4,
      zIndex: 2e9,
    },
    style: {},
  };

  componentDidMount() {
    this.spinner = new SpinJS(this.props.config);
    this.spinner.spin(this._container);
  }

  componentWillUnmount() {
    this.spinner.stop();
  }

  render() {
    const {style} = this.props;

    return (
      <span ref={(container) => (this._container = container)} style={style} />
    );
  }
}
